
export default {
  name: 'SocialShare',
  props: {
    options: {
      default: () => {},
      type: Object,
      required: true,
      network: {
        type: String,
        required: true,
        default: '',
      },
      title: {
        type: String,
        required: true,
        default: '',
      },
      description: {
        type: String,
        required: true,
        default: '',
      },
      url: {
        type: String,
        required: true,
        default: '',
      },
    },
  },
  computed: {
    icon() {
      return `${this.options.network}-line-dark`
    },
  },
}
